<template>
  <v-app>
    <CNotificationsFromStore/>
    <nav-bar/>
    <v-main style="background-color: #F5F6F8; margin-left: 70px">
      <div v-if="newRegions"
           class="d-flex flex-column align-center justify-center"
           style="position: fixed; width: 100%; z-index: 888; height: 100%; ">
        <div style="background-color: rgb(33, 33, 33); opacity: 0.26; width: 100%; height: 100%; "></div>
        <v-card class="d-flex flex-column align-center justify-center"
                style="position: fixed; z-index: 889; width: 92%; margin-left: -70px;">
          <v-card-text
            class="section-header__title main-color__important pb-0"
            style="text-align: justify; text-transform: none">
            В соответствии с пунктом 4 статьи 5 Федерального закона от 17.02.2023 N 19-ФЗ "Об особенностях правового
            регулирования отношений в сферах образования и науки в связи с принятием в Российскую Федерацию Донецкой
            Народной Республики, Луганской Народной Республики, Запорожской области, Херсонской области и образованием в
            составе Российской Федерации новых субъектов - Донецкой Народной Республики, Луганской Народной Республики,
            Запорожской области, Херсонской области и о внесении изменений в отдельные законодательные акты Российской
            Федерации" Контрольные цифры приема на обучение по специальностям и направлениям подготовки и (или)
            укрупненным группам специальностей и направлений подготовки для обучения по имеющим государственную
            аккредитацию (временную государственную аккредитацию) образовательным программам высшего образования (за
            исключением специальностей и направлений подготовки и (или) укрупненных групп специальностей и направлений
            подготовки для обучения по образовательным программам высшего образования в области искусств), а также по
            группам научных специальностей и (или) научным специальностям для обучения по программам подготовки научных
            и научно-педагогических кадров в аспирантуре (адъюнктуре) за счет бюджетных ассигнований федерального
            бюджета на 2024/25, 2025/26, 2026/27, 2027/28 учебные годы устанавливаются организациям, осуществляющим
            образовательную деятельность, расположенным на территориях Донецкой Народной Республики, Луганской Народной
            Республики, Запорожской области, Херсонской области, федеральным органом исполнительной власти,
            осуществляющим функции по выработке и реализации государственной политики и нормативно-правовому
            регулированию в сфере высшего образования, без проведения публичного конкурса по представлению органов
            государственной власти Донецкой Народной Республики, Луганской Народной Республики, Запорожской области,
            Херсонской области, осуществляющих государственное управление в сфере образования.
          </v-card-text>
        </v-card>
      </div>
      <div v-else-if="currentStage < 4 && !checkHost && roleCheck && !isAdmin"
           class="d-flex flex-column align-center justify-center"
           style="position: fixed; width: 100%; z-index: 888; height: 100%; ">
        <div style="background-color: rgb(33, 33, 33); opacity: 0.26; width: 100%; height: 100%; "></div>
        <v-card class="d-flex flex-column align-center justify-center"
                style="position: fixed; z-index: 889; width: 92%; margin-left: -70px;">
          <v-card-text class="section-header__title main-color__important pb-0">
            Доступ к заполнению заявки на открытый публичный конкурс по распределению контрольных цифр приема за счет
            бюджетных ассигнований федерального бюджета будет открыт позже. Следите за новостями на сайте ФГБУ "Интеробразование"
          </v-card-text>
        </v-card>
      </div>
      <v-container>
        <keep-alive include="Contacts,ContactsCo,ContactsRegions,Stage1,Stage2,Stage3,OrgAppeals,Organizations"
                    :exclude="isAdmin ? 'Contacts' : ''">
          <router-view/>
        </keep-alive>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import CNotificationsFromStore from "@/components/Notification/CNotificationsFromStore";
import NavBar from "@/components/Navigation/navBar";
import axios from "axios";
import {mapGetters, mapActions} from "vuex";

export default {
  components: {NavBar, CNotificationsFromStore},
  props: {
    keycloak: Object,
    authenticated: [Object, Promise]
  },
  name: "App",
  computed: {
    ...mapGetters('keycloak', {
      isAdmin: 'isAdmin',
      isRegion: 'isRegion',
      getKeycloakData: 'getKeycloakData',
      getFakeUser: 'getFakeUser',
      userId: 'userId'
    }),
    ...mapGetters('checkFilled', {currentStage: 'currentStage',}),
    ...mapGetters('spr', {getOrgs: 'getOrgs'}),
    roleCheck() {
      return this.keycloak?.realmAccess?.roles?.includes('ORGANIZATION_ROLE')
    },
    newRegions() {
      if (this.currentStage === 8) return false;
      const x = this.getOrgs?.find(el => el.id === this.userId);
      return [94, 95, 96, 97].includes(x?.region?.id)
    },
    checkHost() {
      console.log(window.location.host === 'kcpforms.ined.ru')
      return window.location.host === 'kcpforms.ined.ru'
    }
  },
  created() {
    axios.interceptors.response.use(undefined, err => {
      // eslint-disable-next-line no-unused-vars
      return new Promise(/*function (resolve, reject)*/() => {
        if (process.env.NODE_ENV === 'development') {
          console.log("err.request", err.request)
          console.log("err.response", err.response)
        }
        if (err.request.status === 401) {
          console.log('error', err);
          this.getKeycloakData.updateToken(0).then(refreshed => {
            if (!refreshed) {
              // location.reload()
              this.getKeycloakData.updateToken(0).then(con => console.log('con', con))
            }
          })
        }
        // console.log('interseptors', err.response)
        throw err.response;
      });
    });
    this.setAuthData(this.keycloak);
  },
  methods: {
    ...mapActions('keycloak', {setAuthData: 'setAuthData'})
  },
}
</script>

<style lang="sass">
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined).v-btn--icon
  background: none !important

.tooltip
  cursor: pointer
  position: fixed
  padding: 8px 12px
  border-radius: 4px
  text-align: left
  background: white
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4)
  font-size: 16px
  line-height: 20px
  color: #00599B
  transition: opacity 0.1s ease-out
  z-index: 3000

p, div, span, h1, h2, h3, h4, h5, li, ul
  font-family: "Raleway", sans-serif !important
  font-feature-settings: 'pnum' on, 'lnum' on
  font-weight: 500

.container
  max-width: 2500px !important
  padding: 30px !important
</style>